const PosPermitSearch = () => {
    return (
        <div>
            <h1>PosPermitSearch</h1>
        </div>
    );
};

export default PosPermitSearch;
